// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2HPaQ","label":"CategoryService_label__2KiLX","location":"CategoryService_location__3YNsy"};